import { useMemo } from 'react';
import { buildGoogleMapsRouteUrl } from '../../../lib/google-maps-url.ts';
import { api } from '../../../utils/api.ts';
import { useAnalytics } from '../../analytics/hooks/use-analytics.ts';

type Options = {
    day: string;
    ownerId: string;
    enabled: boolean;
};

type DayRouteMapsUrl = {
    /** Google Maps route through the day's event addresses; undefined while loading or when none has an address. */
    mapsUrl: string | undefined;
    /** Call when the user opens the route, to record it. */
    onOpen: () => void;
};

export function useDayRouteMapsUrl({ day, ownerId, enabled }: Options): DayRouteMapsUrl {
    const sendEvent = useAnalytics();

    const { data: dayEvents } = api.platoUser.query.events.getList.useQuery(
        {
            dateFrom: day,
            dateTo: day,
            ownerId,
        },
        {
            enabled,
        },
    );

    const mapsUrl = useMemo(
        () => (dayEvents ? (buildGoogleMapsRouteUrl(dayEvents) ?? undefined) : undefined),
        [dayEvents],
    );

    const onOpen = (): void => {
        if (!dayEvents) {
            return;
        }

        sendEvent('route_opened_in_maps', {
            event_count: dayEvents.length,
            addresses_count: dayEvents.filter((e) => e.address).length,
            date: day,
        });
    };

    return { mapsUrl, onOpen };
}
